import _ from "lodash";
/**--external-- */
import React, { useRef, useImperativeHandle } from "react";
import propTypes from "prop-types";
import classNames from "classnames";

/**--internal-- */
import { useI18n } from "Hooks";
import {FormTextInput} from "UIComponents/InputTextField";
import DropzoneComponent from "UIComponents/DropzoneComponent";

/**--relative-- */
import classes from "./EditBasicDetails.scss";
import DropZoneButtonComponent from "../DropZoneButtonComponent";

const EditBasicDetails = props => {
  const {
    name,
    code,
    attachments,
    updateOrganizationInformation,
    customRef,
  } = props;

  const { t } = useI18n(["common", "onBoarding"]);

  const nameRef = useRef();

  useImperativeHandle(customRef, () => {
    return {
      isValid: () => nameRef.current.isValid() === 0,
    };
  });

  const headerClasses = classNames("heading-3", classes.header);

  const schoolDetailsHeaderClasses = classNames(
    "heading-5",
    classes.schoolDetailsHeader
  );

  const schoolLogoLabelClasses = classNames(
    "text-label-2",
    classes.schoolLogoLabel
  );

  const logoAttachment = !_.isEmpty(attachments) ? attachments[0] : {};

  return (
    <div className={classes.container}>
      <h3 className={headerClasses}>
        {t("common:edit_with_label", {
          label: t("common:school_information"),
        })}
      </h3>
      <h5 className={schoolDetailsHeaderClasses}>
        {t("onBoarding:school_details")}
      </h5>
      <div className={classes.schoolLogoContainer}>
        <p className={schoolLogoLabelClasses}>{t("onBoarding:school_logo")}</p>
        <DropzoneComponent
          accept="image/jpeg,image/png,image/jpg,image/heic,image/heif"
          onContentUploaded={attachments => {
            updateOrganizationInformation({
              key: "attachments",
              value: attachments,
            });
          }}
          multiple={false}
          renderComponent={
            <DropZoneButtonComponent logoAttachment={logoAttachment} />
          }
        />
      </div>
      <div className={classes.schoolDetailsContainer}>
        <FormTextInput
          value={name}
          updateInputField={name =>
            updateOrganizationInformation({ key: "name", value: name })
          }
          placeholder={t("onBoarding:enter_school_name")}
          size={"x-large"}
          isRequired
          ref={nameRef}
          label={t("onBoarding:school_name")}
        />
        <FormTextInput
          value={code}
          updateInputField={code =>
            updateOrganizationInformation({ key: "code", value: code })
          }
          placeholder={t("onBoarding:enter_school_code")}
          size={"x-large"}
          label={t("onBoarding:school_code_optional")}
        />
      </div>
    </div>
  );
};

EditBasicDetails.propTypes = {
  name: propTypes.string,
  code: propTypes.string,
  logoAttachment: propTypes.object,
  updateOrganizationInformation: propTypes.func,
  customRef: propTypes.object,
};

export default EditBasicDetails;
